export default "__VITE_PUBLIC_ASSET__3236fc12__"